export default __webpack_public_path__ + "static/media/gt7.0667448e.png";